// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3iZVu","name":"ConsentHeader_name__1wawT","birthday":"ConsentHeader_birthday__31_Yy","skeleton":"ConsentHeader_skeleton__3MX0X"};